import { isString } from "util";
import { runningInBrowser } from "~/const/browser";
import { uriConverter } from "~/util/uri-converter";

const searchHistoryKey = "searchHistory";

export type SearchHistoryType = {
  keyword: string;
  type?: "gravure";
};

export const appendSearchHistory = ({ keyword, type }: SearchHistoryType, userId?: string) => {
  if (!runningInBrowser) return;

  const trimmedSearchKeyword = keyword.trim();
  if (trimmedSearchKeyword === "") return;

  const searchHistories = getSearchHistories(userId);

  const filterExistsSameSearchHistory = searchHistories.filter(
    (v) => !(v.keyword === trimmedSearchKeyword && v.type === type)
  );

  // 最新5件のみを保存する
  const latestSearchHistories = [{ keyword: trimmedSearchKeyword, type }, ...filterExistsSameSearchHistory].slice(0, 5);
  saveSearchHistories(latestSearchHistories, userId);
};

export const saveSearchHistories = (searchHistories: SearchHistoryType[], userId?: string) => {
  if (!runningInBrowser) return;

  const searchHistoryForUserIdKey = `${searchHistoryKey}_${userId}`;
  const encodedSearchHistories = window.btoa(uriConverter.encode(JSON.stringify(searchHistories)));
  localStorage.setItem(searchHistoryForUserIdKey, encodedSearchHistories);
};

export const getSearchHistories = (userId?: string): SearchHistoryType[] => {
  if (!runningInBrowser) return [];

  const searchHistoryForUserIdKey = `${searchHistoryKey}_${userId}`;

  // NOTE: 改修前(userIdに紐づかないキー)に保存されている履歴があれば表示する
  const searchHistoriesString = localStorage.getItem(searchHistoryForUserIdKey);
  const searchPrevHistoriesString = localStorage.getItem(searchHistoryKey);

  const decodedSearchHistories = searchHistoriesString
    ? JSON.parse(uriConverter.decode(window.atob(searchHistoriesString)))
    : [];
  const decodedSearchPrevHistories = searchPrevHistoriesString
    ? JSON.parse(uriConverter.decode(window.atob(searchPrevHistoriesString)))
    : [];

  // NOTE: データ変更前の型に対応させるための関数
  const transformHistory = (history: unknown) => {
    return isString(history) ? { keyword: history, type: undefined } : history;
  };

  const mergeHistories = [
    ...decodedSearchHistories.map(transformHistory),
    ...decodedSearchPrevHistories.map(transformHistory),
  ];

  if (!mergeHistories.length) return [];

  // NOTE: userIdに紐づいていない履歴をuserIdに紐づけて保存
  if (searchPrevHistoriesString) {
    const encodedSearchPrevHistories = window.btoa(uriConverter.encode(JSON.stringify(mergeHistories)));
    localStorage.setItem(searchHistoryForUserIdKey, encodedSearchPrevHistories);
    localStorage.removeItem(searchHistoryKey);
  }

  return mergeHistories;
};

export const removeSearchHistory = (removeIndex: number, userId?: string) => {
  if (!runningInBrowser) return;

  const searchHistories = getSearchHistories(userId);
  searchHistories.splice(removeIndex, 1);
  saveSearchHistories(searchHistories, userId);
};
